import { render, staticRenderFns } from "./ListarWhatsapp.vue?vue&type=template&id=1b80043b"
import script from "./ListarWhatsapp.vue?vue&type=script&lang=js"
export * from "./ListarWhatsapp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/dartanghanvani/Documents/workspace/recuperi-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1b80043b')) {
      api.createRecord('1b80043b', component.options)
    } else {
      api.reload('1b80043b', component.options)
    }
    module.hot.accept("./ListarWhatsapp.vue?vue&type=template&id=1b80043b", function () {
      api.rerender('1b80043b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/ListarWhatsapp.vue"
export default component.exports